/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DirectivesModule } from './../../directives/directives.module';
import { CarouselModule } from 'angular-bootstrap-md';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PipesModule } from '../../pipes/pipes.module';
import { CustomTooltipModule } from '../custom-tooltip/custom-tooltip.module';
import { ProductCommentBoxModule } from '../product-comment-box/product-comment-box.module';
import { ProductCommentModule } from '../product-comment/product-comment.module';
import { ProductLikeModule } from '../product-like/product-like.module';
import { ProductBookmarkModule } from '../product-bookmark/product-bookmark.module';
import { CommonSuggestionModule } from '../common-suggestion/common-suggestion.module';
import { PdfViewModule } from '../pdf-view/pdf-view.module';
import { ShakaPlayerModule } from '../../shaka-player/shaka-player.module';
import { ConnectionCardModule } from '../../connection/connection-card/connection-card.module';
import { ChannelUserCardModule } from '../../web-channel/channel-user-card/channel-user-card.module';
import { FeedCardModule } from '../../web/feed-card/feed-card.module';
import { WebinarCardModule } from '../../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { WebDoctalkCardModule } from '../../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { ClinicalResourceCardModule } from 'src/app/clinical-resource/clinical-resource-card/clinical-resource-card.module';


/**
 * Component imports.
 */
import { WebFeedDetailComponent } from './web-feed-detail.component';
import { ConfirmModalModule } from '../confirm-modal/confirm-modal.module';
import { PostedInComponent } from './posted-in/posted-in.component';



@NgModule({
  declarations: [
    WebFeedDetailComponent,
    PostedInComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    CarouselModule,
    PipesModule,
    CustomTooltipModule,
    ProductCommentModule,
    ProductCommentBoxModule,
    ProductLikeModule,
    ProductBookmarkModule,
    CommonSuggestionModule,
    PdfViewModule,
    PerfectScrollbarModule,
    ShakaPlayerModule,
    ConnectionCardModule,
    ChannelUserCardModule,
    ConfirmModalModule,
    AccordionModule,
    FeedCardModule,
    WebinarCardModule,
    WebDoctalkCardModule,
    ClinicalResourceCardModule
  ],
  exports: [
    WebFeedDetailComponent,
  ]
})
export class WebFeedDetailModule { }
